import { render, staticRenderFns } from "./ownership.html?vue&type=template&id=78bfc172&external"
import script from "./ownership.vue?vue&type=script&lang=js"
export * from "./ownership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports